import { useEffect, useRef } from 'react';
var CLICK_EVENTS = ['mousedown', 'touchstart'];
export function useClickOutside(handler, outsideRef) {
    var ref = outsideRef || useRef();
    useEffect(function () {
        var listener = function (event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        CLICK_EVENTS.forEach(function (fn) { return document.addEventListener(fn, listener); });
        return function () {
            CLICK_EVENTS.forEach(function (fn) { return document.removeEventListener(fn, listener); });
        };
    }, [ref, handler]);
    return ref;
}
